const domain = window.location.host;
let API_PATH = "";
if (domain.indexOf("developer.gartner.com") !== -1) {
  API_PATH = "https://toolsdv.gartner.com";
}

export const Constants = {
  API: {
    API_PATH: API_PATH,
    BASE_URL: "/api/cyber-risk/v1",
    SEARCH: "/search/vendor",
  },
  COMMON: {
    END_USER_ROLE: ["end-user", "gartner_associate"],
    ADMIN_PANEL: "admin-panel",
    LOGO_ALTERNATE_TEXT: "Gartner",
    VENDOR: "vendor",
    GLOBAL_SEARCH: "GLOBAL_SEARCH",
    ASSESSOR: "end-user-assessor",
  },
  DASHBOARD_LABEL: 'Dashboard',
  ROUTES: {
    BASE_URL: "/cybersecurity-insights",
    DASHBOARD: "/dashboard",
    SETTINGS: "/settings",
    GUEST_PROFILE: "/risk-profile/browse",
    RISK_PROFILE: "/risk-profile",
    RISK_PROFILE_PARAMS: "?profileId=",
    RISK_PROFILE_PARAMS_SHELL: "&shell=true",
    ACCESS_DENIED: "/access-denied",
    TEAM_ACTIVITY: "/team-activity",
    EDIT: "/edit",
    TEAM_DRAWER_PARAM: 'teamDrawer',
    HOMEPAGE: "/",
    ALL_VENDORS: "/all-vendors",
    ALL_INSIGHTS_ALERTS: "/all-insights-alerts",
    IMPORT_VENDORS: '/import-vendors',
    MANAGE_VENDORS: "/manage-vendors",
  },
  LEFT_NAVIGATION_BODY_CLASS: "apollo--hasLeftNavigation",
  EXCLUDED_PATHS_FOR_LEFT_NAV: ["lets-get-started"],
  ROLE: ["gartner_associate", "end-user", "vendor", "end-user-assessor"],
  HEADER: {
    SECONDARY_LOGO_LABEL: "Third-Party Cybersecurity Insights",
    SIGN_OUT: "Sign Out",
    YOUR_TEAM: "Manage Team",
    NOTIFICATION_MANAGER: "Notification Manager",
    SETTINGS: 'Settings',
    PROFILE_PREFERENCES: "Profile Preferences",
  },
  HOST: {
    PROD: "tools.pdotools.aws.gartner.com",
    DEV: "tools.pdotoolsdev.aws.gartner.com",
    QA: "tools.pdotoolsqa.aws.gartner.com",
  },
  URLS: {
    GARTNER: "https://www.gartner.com",
    GARTNER_QA: "https://gcom.pdoqa.aws.gartner.com",
    GARTNER_DEV: "https://gcom.pdodev.aws.gartner.com",
  },
  HELP: {
    LABEL: "Help",
    URL: "https://intercom.help/gartner-third-party-cybersecurity-insights",
  },
  SEARCH: {
    IN_MY_ORG_TITLE: "IN MY ORGANIZATION",
    OUTSIZE_ORG_TITLE: "OUTSIDE YOUR ORGANIZATION",
    NO_RESULT_IN_ORG: "No matches in your organization",
    NO_RESULT_OUTSIDE_ORG:
      "No profiles match your search. Try another search term.",
    CHAR_LIMIT: 2,
    PLACEHOLDER: "Search Vendors/Products",
    LAST_OPTION_LABEL: `Vendor profile does not exist? Add Vendor "`,
  },
  APOLLO_HOST: {
    DEV: 'tools.pdotoolsdev.aws.gartner.com, toolsdv.gartner.com, developer.gartner.com',
    QA: 'tools.pdotoolsqa.aws.gartner.com, toolsqa.gartner.com, tools-ha.pdotoolsqa.aws.gartner.com',
    DEMO: 'demo.pdotoolsqa.aws.gartner.com',
  },
  TOOLS_ENV: {
    DEV: 'https://toolsdv.gartner.com',
    QA: 'https://toolsqa.gartner.com',
    PROD: 'https://tools.gartner.com',
    DEMO: 'https://demo.pdotoolsqa.aws.gartner.com',
  },
  IMAGE: {
    PATH: '/assets/common/images/gartner-logos/',
    GARTNER_LOGO: 'gartner-logo-dark.svg',
  },
  LOGOUT_EVENT_KEY: "logout-event",

};
